module.exports = __webpack_public_path__ + "img/gg.00866d1c.png";